import { Link, useNavigate } from "react-router-dom";

const StaticPageHeader = ({ currentPage }) => {
  const navigate = useNavigate();

  return (
    <header className="bg-white/80 backdrop-blur-lg shadow-sm border-b border-white/40">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Back button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1.5 text-slate-600 hover:text-slate-900 transition-colors text-sm font-medium"
          aria-label="Go back to previous page"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span className="hidden sm:inline">Back</span>
        </button>

        {/* Ubay Logo */}
        <Link to="/" aria-label="Go to Ubay home">
          <img
            src="/assets/imgs/Ubay_Logo_N.png"
            alt="Ubay – Daily Islamic Quizzes"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </Link>
      </div>

      {/* Breadcrumbs */}
      <div className="max-w-5xl mx-auto px-4 pb-2">
        <nav aria-label="Breadcrumb">
          <ol className="flex items-center gap-1.5 text-sm text-slate-500">
            <li>
              <Link to="/" className="hover:text-slate-900 transition-colors">
                Home
              </Link>
            </li>
            <li aria-hidden="true">
              <svg
                className="w-3 h-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </li>
            <li className="text-slate-900 font-medium" aria-current="page">
              {currentPage}
            </li>
          </ol>
        </nav>
      </div>
    </header>
  );
};

export default StaticPageHeader;
